import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
import Icon from './Icon';
import ThemeIcons from '../../theme/Icons';
import FormStylesOptions from '../../constants/FormStylesOptions';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 0;
  padding: ${props => props.customStyles.padding}px;
  cursor: pointer;
`;

const StyledText = styled.span`
  flex: 1;
  word-break: break-word;
  font-size: ${props => props.customStyles.fontSize}px;
  color: ${props => props.customStyles.fontColor};
  font-style: ${props => props.customStyles.fontStyle};
  font-weight: ${props => props.customStyles.fontWeight};
  text-align: ${props => props.customStyles.textAlign};
  text-transform: ${props => props.customStyles.textTransform};
  text-decoration: ${props => props.customStyles.textDecoration};
  min-width: 0;

  text-overflow: ${props => props.customStyles.textOverflow === FormStylesOptions.textOverflowEllipsis ? 'ellipsis' : 'normal'};
  white-space: ${props => props.customStyles.textOverflow === FormStylesOptions.textOverflowEllipsis ? 'nowrap' : 'normal'};
  overflow: ${props => props.customStyles.textOverflow === FormStylesOptions.textOverflowEllipsis ? 'hidden' : 'visible'};

`;

const StyledIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  cursor: pointer;
  color: #888;
  margin-left: 4px;
  flex-shrink: 0;
  transition: color 0.2s ease;
  font-size: 12px;

  &:hover {
    color: ${props => props.customStyles.primaryColor};
  }
`;

const DateTimeDisplay = ({
  value = null,
  timezone = null,
  format,
  onClick = null,
  disabled = false,
  customStyles = {}
}) => {
  let formatted = '';

  if (value) {
    if (timezone) {
      formatted = dayjs(value).tz(timezone).format(format);
    } else {
      formatted = dayjs(value).format(format);
    }
  }

  return (
    <StyledWrapper 
      customStyles={customStyles}
      onClick={onClick}
    >
      <StyledText customStyles={customStyles}>
        {formatted}
      </StyledText>
      {!disabled && typeof onClick === 'function' && (
        <StyledIcon 
          customStyles={customStyles}
          title="Edit date/time"
        >
          <Icon icon={ThemeIcons.settings.formatDateTime}/>
        </StyledIcon>
      )}
    </StyledWrapper>
  );
};

DateTimeDisplay.propTypes = {
  value: PropTypes.number,
  timezone: PropTypes.string,
  format: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  customStyles: PropTypes.shape({
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,
    primaryColor: PropTypes.string
  })
};

export default DateTimeDisplay;

